import { LogsAPI } from '@/api';
import { IApiError } from '@/models/apiError.model';
import { IGetActionLogsDTO, IGetActionLogsResponse } from '@/models/logs.model';
import { formatApiError } from '@/utils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { LOGS_SLICE_NAME } from './models';

export const getActionLogs = createAsyncThunk<
  IGetActionLogsResponse,
  IGetActionLogsDTO,
  { serializedErrorType: IApiError }
>(
  `${LOGS_SLICE_NAME}/getOrders`,
  async (data) => {
    const response = await LogsAPI.getActionLogs(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
